module.exports = __webpack_public_path__ + "static/media/video_cover_analytics.35019b4a.jpg";